import { render, staticRenderFns } from "./FlashOverlay.vue?vue&type=template&id=2218c154&scoped=true"
import script from "./FlashOverlay.vue?vue&type=script&lang=js"
export * from "./FlashOverlay.vue?vue&type=script&lang=js"
import style0 from "./FlashOverlay.vue?vue&type=style&index=0&id=2218c154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218c154",
  null
  
)

export default component.exports